import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { LayoutType } from '../models/layout-type';

@Injectable({
  providedIn: 'root'
})
export class LayoutTypeService extends BaseService<LayoutType> {

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string            
  ) { 
    super(http,rootUrl,'Plasard/PlasardLayoutType');
  }
}
